module.exports = __webpack_public_path__ + "static/media/banner_branding@2x.5f6340a8.png";